export default "__VITE_ASSET__DnII6ZAI__"